function waitForElement(selector , timeout = 10000) {
  return new Promise(function(resolve, reject) {
    const interval = 1000; // ms
    const start = Date.now();

    const timer = setInterval(function() {
      let el = document.querySelector(selector);
      if (el) {
        clearInterval(timer);
        resolve(el);
      } else if (Date.now() - start > timeout) {
        clearInterval(timer);
        reject(new Error('Timed out waiting for ' + selector));
      }
    }, interval);
  });
}




//# REMOVING THE .sold-out CLASS FROM THE ADD TO CART BUTTON WHEN VARIANT IS AVAILABLE
document.addEventListener("DOMContentLoaded", (event) => {
  const productForm = document.querySelector('.product-form');
  if(!productForm) return;
  
  const addToCartButtons = productForm.querySelectorAll('.single-add-to-cart-button');
  document.addEventListener("product:variant-change", function (evt) {
    let currentVariant = evt.detail.variant;
    if(currentVariant.available) {
      addToCartButtons.forEach(addToCartButton => {
        addToCartButton.classList.remove('sold-out');
      });
    }
  });
});


document.addEventListener("DOMContentLoaded", (event) => {
  let items = [],
      index,
      container = document.querySelector('section.product-section');  
  let productGallery = document.getElementById('Product-Slider');
  let productGalleryFlickity = window.productGalleryFlickity || new Flickity(productGallery);

  //if(!container) return;
  let pswpContainer = container.querySelectorAll('.pswp')[0];
  let pswp = window.productPSWP;
  if (pswp) {
    pswpContainer.on('destroy', function() {
      // if(pswpContainer.classList.contains('pswp--visible') && pswpContainer.querySelector('.pswp__button.pswp__counter').innerHTML != "") {
      itemCounterHTML = pswpContainer.querySelector('.pswp__button.pswp__counter').innerHTML;
      itemArray = itemCounterHTML.split('/');
      //currentIndex = parseInt(itemArray[0].trim()) - 1;
      currentIndex = parseInt(itemArray[0].trim()) ;
      productGalleryFlickity.select(parseInt(currentIndex), false, false);
    });
  }
  

  const pswpJustClosed = observeInnerHTMLChanges(pswpContainer, () => {
    let itemCounter,
        itemCounterHTML,
        itemArray,
        currentIndex;

    // if(pswpContainer.classList.contains('pswp--visible') && pswpContainer.querySelector('.pswp__button.pswp__counter').innerHTML != "") {
    itemCounterHTML = pswpContainer.querySelector('.pswp__button.pswp__counter').innerHTML;
    itemArray = itemCounterHTML.split('/');
    //currentIndex = parseInt(itemArray[0].trim()) - 1;
    currentIndex = parseInt(itemArray[0].trim()) ;
    productGalleryFlickity.select(parseInt(currentIndex), false, false);
  });

  function observeInnerHTMLChanges(element, callback) {
    const observer = new MutationObserver(mutationsList => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          callback();
          break;
        }
      }
    });

    observer.observe(element, {
      childList: true,
      subtree: true,
      characterData: true
    });
    return observer;
  }

  //flkty.append(productGallery.querySelector('.no-variant--image'));
  verticalCenterSliderThumbnail();

  addIdToRecentlyViewed(document.querySelector('[data-handle]').dataset.handle);
});

function verticalCenterSliderThumbnail() {
  let thumbnailsContainer = document.getElementById('Product-Thumbnails');
  let thumbnails = thumbnailsContainer.querySelectorAll('.is-initial-selected');
  let active_thumb = thumbnails[0];

  if(!active_thumb) return;

  requestAnimationFrame(() => {
    //console.log(active_thumb.offsetParent);
    if (active_thumb.offsetParent === null) return;
        
    const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
    windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
    active_thumb.parentElement.scrollTo({
      left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
      top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
      behavior: 'smooth'
    });
  });
}

//UPDATE POSITION PROPERTY IN PRODUCT FORM
document.addEventListener("cart:item-added", function (evt) {
  let positionInput = document.querySelector('.product-form [name="properties[_position]"]');
  positionInput.value = parseInt(positionInput.value) - 1;
  //console.log("ITEM ADDED TO CART", evt.detail.cart);

  //OPEN CART DRAWER WHEN ITEM IS ADDED
  const cartDrawerContainer = document.getElementById('CartDrawerContainer');
  if(cartDrawerContainer) {
    cartDrawerContainer.classList.add('active');
  }
});

document.addEventListener("line-item:change:end", function (evt) {
  let positionInput = document.querySelector('.product-form [name="properties[_position]"]');
  if(evt.detail.cart.items_removed.length > 0) {
    positionInput.value = parseInt(positionInput.value) + 1;
  } else if(evt.detail.cart.items_added.length > 0) {
    positionInput.value = parseInt(positionInput.value) - 1;
  }
  //console.log("LINE ITEM CHANGED", evt.detail.product);
});


/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}


  /********************************/
 /**** VARIANT FORCE REDIRECT ****/
/********************************/
let hasVariantRedirect = false;
let variantRedirectData; 
if(document.getElementById('VariantForceRedirect'))  {
  variantRedirectData = JSON.parse(document.getElementById('VariantForceRedirect').textContent);
  hasVariantRedirect = true;
}

document.addEventListener("DOMContentLoaded", (event) => {  
  if(!document.body.classList.contains('template-product')) return;
  if(!hasVariantRedirect) return;
  
  let datasetVariantId, selectedVariant, redirectToUrl;
  if(variantRedirectData['product_has_only_default_variant'] == true) {    
    redirectToUrl = (variantRedirectData.variants[0]['force_redirect_url']).toString();
  } else {
    datasetVariantId = document.querySelector('.variant-selects').dataset.currentVariant;
    selectedVariant = variantRedirectData.variants.find(variant => variant.variant_id == datasetVariantId);
    // console.log("selected", selectedVariant);
    redirectToUrl = selectedVariant['force_redirect_url'];
  }

  if (redirectToUrl == "") return;
  // console.log("URL1", redirectToUrl);
  window.location.href = redirectToUrl;  
});

document.addEventListener("product:variant-change", function (evt) {
  if(!hasVariantRedirect) return;
  const selectedVariant = variantRedirectData.variants.find(variant => variant.variant_id == evt.detail.variant.id); 
  //if(!selectedVariant['force_redirect_url'] || selectedVariant['force_redirect_url'] == '' || selectedVariant['force_redirect_url'] == 'undefined') return;
  // console.log("selected", selectedVariant);
  if(!selectedVariant || selectedVariant['force_redirect_url'] == "") return;
  window.location.href = selectedVariant['force_redirect_url'];
});


  /********************************/
 /**** PRODUCT FORCE REDIRECT ****/
/********************************/
document.addEventListener("DOMContentLoaded", (event) => {   
  if(document.getElementById('RedirectUrl')) {
    const redirectUrl = document.getElementById('RedirectUrl').value;
    if(redirectUrl) {
      let splitString = redirectUrl.split('/');
      // console.log("URL2", splitString[3] + splitString[4]);
      if(splitString) {
        window.location.href = "/"+splitString[3] +"/"+ splitString[4];
      }
    }
  }
});


  /**********************************************/
 /**** EASIFY CHANGE VARIANT ON SIZE SELECT ****/
/**********************************************/
// waitForElement('input[name="properties[• Pet measurements]"]', 7000)
// .then(function(el) {
//   let tpoOptionType, selectedSize, lastSize;
//   let sizes = [];

//   const easifySizeOptionsContainer = el.closest('.tpo_option-input-inner').nextElementSibling;
//   if(!easifySizeOptionsContainer) return;    
//   sizesOption = document.querySelectorAll('input[name="Size"]');
//   if(!sizesOption) return;
//   sizesOption.forEach(size => sizes.push(size.value));
//   sizes.push("XL");
//   //console.log(sizes);
//   easifySizeOptionsContainer.querySelectorAll('button.tpo_option-type-selection').forEach( (button) => {
//     // tpoLabel = button.querySelector('.tpo_option_type_description').previousElementSibling;
//     //tpoLabel.innerHTML = tpoLabel.innerHTML.replace('&mdash;','<br>');
//     // tpoLabel.innerHTML = tpoLabel.innerHTML.replaceAll('—','<br>');
//     button.addEventListener('click', () => {
//       if(!button.querySelector('.tpo_option_type_description')) return;
//       tpoOptionType = button.querySelector('.tpo_option_type_description').textContent;
      
//       if(tpoOptionType.includes('|')) {
//         selectedSize = tpoOptionType.split('|');
//         lastSize = selectedSize.at(0).trim();
//         lastSize = lastSize.at(-1);
//       } else {
//         selectedSize = tpoOptionType.split(' ');
//         lastSize = selectedSize.at(-1).trim();
//       }
      
//       if(lastSize == "XL") lastSize = "L";
//       let found = sizes.find(size => size == lastSize);
//       // console.log("FOUND SIZE", found);
//       if(document.querySelector(`input[value="${found}"]`)) {
//         document.querySelector(`input[value="${found}"]`).click();          
//       }
//       return;
//     });
//     return;
//   });
// })
// .catch(function(err) {
//   console.warn(err);
// });




  /**********************************************/
 /**** Easify | Replace all '—' with a <br> ****/
/**********************************************/
waitForElement('.tpo_option-set-container', 10000)
.then(function(el){
  let buttons = el.querySelectorAll('.tpo_option-type-selection.below_value');
  buttons.forEach((button) => {    
    //button.querySelector('.tpo_option_type_label_wrapper').innerHTML = button.querySelector('.tpo_option_type_label_wrapper').innerHTML.replaceAll('—','<br>');
    // if(!button.querySelector('.tpo_option_type_description.below_value')) return;
     button.innerHTML = button.innerHTML.replaceAll('—','<br>');
  });
})
.catch(function(err) {
  console.warn(err);
});





  /*****************************************************/
 /**** VITALS BACK IN STOCK BUTTON | VARIANT LEVEL ****/
/*****************************************************/
/**
 *  @class
 *  @function VitalsBackInStock
 */
class VitalsBackInStock {
  constructor() {
    this.container = document.querySelector('.variant-selects');
    this.productInfo = this.container.closest('.product-information');
    this.sectionId = this.container.dataset.section;

    this.form = this.container.closest('.product-information').querySelector('.product-form .form');
    this.button = document.getElementById('vitals-back_in_stock');

    this.data = JSON.parse(document.getElementById('ProductData').textContent);
    //console.log("DATA", this.data);
    this.productHideBackInStock = this.data.product_custom_metafields.hide_back_in_stock_form;
    document.addEventListener("product:variant-change", this.checkBackInStock.bind(this));
  }

  checkBackInStock(evt) {    
    if(!this.data) return;
    this.selectedVariant = this.data.variants.find(variant => variant.id == evt.detail.variant.id);
    console.log("VARIANT", this.selectedVariant);
    // let hideBackInStock = this.selectedVariant['meetafields']['hideBackInStock'];
    let hideBackInStock = this.selectedVariant.metafields.hideBackInStock;
    console.log("BIS", hideBackInStock);
    console.log("PBIS", this.productHideBackInStock);
    //if(this.button.innerHTML == "" || hideBackInStock == "") return;
    if(typeof this.productHideBackInStock === 'undefined') {
      console.log("HERE");
      if(hideBackInStock) {
        this.productInfo.classList.add('back-in-stock-button--false');
      } else if(!hideBackInStock || hideBackInStock == "") {
        this.productInfo.classList.remove('back-in-stock-button--false');
      } else {
        this.productInfo.classList.remove('back-in-stock-button--false');
      }
    }
  }
}
window.addEventListener('load', (event) => {
  if(document.getElementById('vitals-back_in_stock')) {
    if(typeof VitalsBackInStock !== 'undefined') {
      new VitalsBackInStock();
    }    
  }
});